export default __webpack_public_path__ + "static/media/GooglePay.4db3ab28.svg";